import styled from 'styled-components';
import { flexbox,
  alignItems,
  flexDirection, justifyContent } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const Wrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column-reverse')};
    ${alignItems('center')};
    ${justifyContent('space-between')};

    background-color: #eaf9f9;
    border-right: 1px solid ${colours.grey[400]};
    height: 100%;
    min-width: 53px;
    max-width: 53px;
    position: relative;
    cursor: pointer;
`;
});

const Name = styled.div((props) => {
  const { palette } = ThemeHelper.getTheme(props);

  return `
  ${flexbox()};
  ${alignItems('center')};

    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    transform: rotate(-90deg);

    box-sizing: border-box;
    padding-left: 20px;
    height: 52px;
    width: 128px;
    font-size: 12px;
    color: ${palette.primary.dark};
`;
});

const Icon = styled.span`
    ${flexbox()};
    ${alignItems('center')};
    
    height: 20px;
    cursor: pointer;
`;

const Help = styled.div`
    ${flexbox()};
    ${alignItems('center')};

    cursor: pointer;
    width: 100%;
    height: 20px;
    text-align: center;
    
    [class^="svgIconComponent"] {
      width: 23px;
    }
    
    .iconWrapper {
      ${flexbox()};
      ${justifyContent('center')};
    
      width: 100%;
    }
    
    .number {
         position: relative;
         color: red;
         font-weight: 600;
         text-align: center;
         left: -26px;
         top: -2px;
       }
`;

const Preview = styled.div((props) => {
  const { colours, palette } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${alignItems('center')};

    cursor: pointer;
    width: 100%;
    height: 30px;
    padding-left: 10px;
    color: ${palette.primary.dark};
    border-top: 1px solid ${colours.grey[400]};

    [class^="svgIconComponent"] {
      width: auto;
      margin-right: 10px;

      .isvg {
        ${flexbox()};
      }
    }

    &:hover {
      color: ${palette.secondary.dark};
    }
  `;
});

export {
  Wrapper,
  Name,
  Icon,
  Help,
  Preview
};
